/**
 * The sorting state is split into mutable and immutable state. Both may come pre-loaded from the server or the URL,
 * but only the mutable state should be altered during the lifetime of the app. The rest of the app relies on the
 * immutability of the immutable part of the sorting state.
 *
 * */


import { CALCULATE_SORTED_ROW_KEYS, SET_SORT } from "../actions/sorting";
import { calculateSortedDataKeys } from "../../utils/data.transformations/sortedDataKeys";

export const initialMutableSortingState = {
    sortBy: null,
    descending: true,
    sortedRowKeys: [],
};


export function mutableSorting(state = initialMutableSortingState, action) {
    switch (action.type) {

        case SET_SORT:

            const sortByMatchesCurrent = state.sortBy === action.columnName;

            return {
                ...state,
                sortBy: action.columnName,
                descending: sortByMatchesCurrent ? !state.descending : true  // toggle direction if same column, else reset
            };

        case CALCULATE_SORTED_ROW_KEYS:

            const sortedRowKeys = calculateSortedDataKeys(
                action.initialRowKeys, action.rows, state.sortBy, state.descending
            );

            return {
                ...state,
                sortedRowKeys: sortedRowKeys,
            };


        default:
            return state
    }
}
